import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Auth from './pages/Auth';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import Numerisation from './pages/Numerisation';
import Decisions from './pages/Decisions';
import DecisionDetail from './pages/DecisionDetail';
import Recherche from './pages/Recherche';
import AdminDashboard from './pages/AdminDashboard';
import AdminNumerisation from './pages/AdminNumerisation';
import AdminDecisions from './pages/AdminDecisions';
import AdminRoles from './pages/AdminRoles';
import AdminReassignation from './pages/AdminReassignation';
import Users from './pages/Users';
import Historique from './pages/Historique';
import Profile from './pages/Profile';
import UserDetail from './pages/UserDetail';
import ControleQualite from './pages/ControleQualite';
import DecisionInterne from './pages/DecisionInterne';
import DecisionInterneDetail from './pages/DecisionInterneDetail';
import JurisprudenceNationale from './pages/JurisprudenceNationale';
import JurisprudenceNationaleDetail from './pages/JurisprudenceNationaleDetail';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Redirect root to login */}
        <Route path="/" element={<Navigate to="/connexion" replace />} />

        {/* Auth - login only */}
        <Route path="/connexion" element={<Auth />} />

        {/* Espace Agent (TCA) */}
        <Route path="/espace-tca" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="numerisation" element={<Numerisation />} />
          <Route path="decisions" element={<Decisions />} />
          <Route path="decisions/:id" element={<DecisionDetail />} />
          <Route path="recherche" element={<Recherche />} />
          <Route path="controle-qualite" element={<ControleQualite />} />
          <Route path="decisions-internes" element={<DecisionInterne />} />
          <Route path="decisions-internes/:id" element={<DecisionInterneDetail />} />
          <Route path="jurisprudence-nationale" element={<JurisprudenceNationale />} />
          <Route path="jurisprudence-nationale/:id" element={<JurisprudenceNationaleDetail />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Espace Admin */}
        <Route path="/espace-admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="utilisateurs" element={<Users />} />
          <Route path="utilisateurs/:id" element={<UserDetail />} />
          <Route path="roles" element={<AdminRoles />} />
          <Route path="reassignation" element={<AdminReassignation />} />
          <Route path="numerisation" element={<AdminNumerisation />} />
          <Route path="decisions" element={<AdminDecisions />} />
          <Route path="decisions/:id" element={<DecisionDetail />} />
          <Route path="historique" element={<Historique />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/connexion" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
